const FALLBACK =
  "https://images.unsplash.com/photo-1621510564330-c87695020b53?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxwaXp6YSUyMGRhcmslMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc3ODk3MTAzM3ww&ixlib=rb-4.1.0&q=85";

function formatEUR(v) {
  return v.toFixed(2).replace(".", ",") + " €";
}

export default function MenuCard({ pizza }) {
  const { name, ingredients, prices, img, slug } = pizza;

  return (
    <article
      data-testid={`pizza-card-${slug}`}
      className="menu-card bg-white border border-[#e5e0d5] rounded-2xl p-5 sm:p-6 flex gap-5 sm:gap-7 items-center relative overflow-hidden"
    >
      {/* Image cercle */}
      <div className="relative shrink-0">
        <div className="absolute inset-0 rounded-full bg-[#c23b22]/10 blur-xl"></div>
        <div className="relative w-24 h-24 sm:w-32 sm:h-32 rounded-full overflow-hidden ring-4 ring-white shadow-[0_8px_22px_-12px_rgba(0,0,0,0.35)] bg-[#f6efe2]">
          <img
            src={img || FALLBACK}
            onError={(e) => {
              e.currentTarget.src = FALLBACK;
            }}
            alt={`Pizza ${name}`}
            loading="lazy"
            data-testid={`pizza-img-${slug}`}
            className="menu-img w-full h-full object-cover"
          />
        </div>
      </div>

      {/* Contenu */}
      <div className="min-w-0 flex-1">
        <header className="flex items-start justify-between gap-3">
          <h3
            data-testid={`pizza-name-${slug}`}
            className="font-serif text-xl sm:text-2xl text-[#1a1a1a] leading-tight"
          >
            {name}
          </h3>
        </header>
        <p
          data-testid={`pizza-ingredients-${slug}`}
          className="mt-2 text-sm sm:text-[15px] text-[#5c5c5c] leading-relaxed"
        >
          {ingredients}
        </p>

        <div className="mt-4 flex flex-wrap items-baseline gap-x-5 gap-y-1.5">
          {prices.moyenne != null && (
            <span
              data-testid={`pizza-price-moyenne-${slug}`}
              className="inline-flex items-baseline gap-1.5"
            >
              <span className="text-[10px] uppercase tracking-[0.18em] text-[#5c5c5c]">
                Moyenne
              </span>
              <span className="font-serif text-base sm:text-lg text-[#c23b22] font-semibold">
                {formatEUR(prices.moyenne)}
              </span>
            </span>
          )}
          {prices.grande != null && (
            <span
              data-testid={`pizza-price-grande-${slug}`}
              className="inline-flex items-baseline gap-1.5"
            >
              <span className="text-[10px] uppercase tracking-[0.18em] text-[#5c5c5c]">
                Grande
              </span>
              <span className="font-serif text-base sm:text-lg text-[#c23b22] font-semibold">
                {formatEUR(prices.grande)}
              </span>
            </span>
          )}
        </div>
      </div>
    </article>
  );
}
